// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"94d94c3c","396":"8a6f24ea","453":"16dd0182","455":"327aaf9a","857":"56ca3133","977":"fae0d00e"}[chunkId] + ".chunk.js";
};